var map = {
	"./en-US": [
		96745,
		745
	],
	"./en-US copy": [
		27524,
		143
	],
	"./en-US copy.js": [
		27524,
		143
	],
	"./en-US.js": [
		96745,
		745
	],
	"./useLocale": [
		64162
	],
	"./useLocale.js": [
		64162
	],
	"./zh-CN": [
		16671,
		671
	],
	"./zh-CN.js": [
		16671,
		671
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 77832;
module.exports = webpackAsyncContext;